<ion-modal [isOpen]="modalConfig.isOpen" class="spot-detail-modal" (didDismiss)="onDidDismissModal()">
    <ng-template>
        <ion-content>
            <ion-button (click)="closeModal()" fill="clear" class="close-button ion-float-end ion-no-padding">
                <ion-icon color="dark" slot="icon-only" name="close"></ion-icon>
            </ion-button>

            <div *ngIf="((useLang === 'ja' && spot?.eventTag?.includes('promotion')) ||
      (useLang !== 'ja' && spot?.eventTag?.includes('promotion-' + useLang)))
    " class="pr-tag ion-float-end"
            >
                PR
            </div>

            <div class="modal-overall">
                <div class="locationHeader">
                    <ion-row>
                        <div *ngIf="spot?.locationUrl; else noUrl"
                             (click)="stateMapDetail()"
                        >
                            <ng-container *ngTemplateOutlet="spotName"></ng-container>
                        </div>
                        <ng-template #noUrl>
                            <ng-container *ngTemplateOutlet="spotName"></ng-container>
                        </ng-template>
                    </ion-row>
                </div>

                <ng-template #spotName>
                    <h6 *ngIf="isDisplayJapaneseLocationName; else translatedName"
                        [class]="spot?.locationUrl ? 'locationHeader__outside-link-modal-title' : 'locationHeader__modal-title'"
                    >
                        {{ spot?.name }}
                        <ion-icon *ngIf="spot?.locationUrl" class="locationHeader__outside-ling-icon"
                                  src="assets/icon/shared/outside_link_icon.svg"></ion-icon>
                    </h6>

                    <ng-template #translatedName>
                        <h6 [class]="spot?.translation?.[useLang]?.locationUrl ? 'locationHeader__outside-link-modal-title' : 'locationHeader__modal-title'"
                        >
                            {{ spot?.translation?.[useLang]?.name }}
                            <ion-icon *ngIf="spot?.translation?.[useLang]?.locationUrl"
                                      class="locationHeader__outside-ling-icon"
                                      src="assets/icon/shared/outside_link_icon.svg"></ion-icon>
                        </h6>
                    </ng-template>
                </ng-template>

                <app-spot-information [locationState]="spot" [useLang]="useLang"></app-spot-information>

                <ion-row class="bottomButtons">
                    <ion-col size="6">
                        <ng-container>
                            <ion-button
                                    shape="round"
                                    fill="outline"
                                    color="secondary"
                                    class="bottomButtons__button"
                                    [disabled]="!isFavoriteButtonEnable"
                            >
                                <ion-icon name="heart-outline" slot="start" class="custom-icon-size"></ion-icon>
                                お気に入り
                            </ion-button>
                        </ng-container>
                    </ion-col>
                    <ion-col size="6">
                        <ion-button ngx-translate shape="round" class="bottomButtons__button" (click)="goLocation()"
                        >ここに行く
                        </ion-button>
                    </ion-col>
                </ion-row>
            </div>
        </ion-content>
    </ng-template>
</ion-modal>
